import { SettingContentComponent } from './setting-content';
import React, { useEffect, useState } from 'react';
import { MainWrapper } from '../main-wrapper';
import { IComponentProps } from '../../../model/studio';
import getFormatMessage from '../../../locales/get-format-message';
import { getMidasAccountInfo } from '../../../api';
import { IAPICompanyFullInfo } from '../../../model/api-modules';
import styles from './index.module.scss';
import { PermissionCheck } from '../../component/permission-check';
import { IMidasAccountInfo } from '../../../model/billing-center';
import { useDispatch } from 'react-redux';
import { getStudioCert } from '../../../store/modules/studio';
import { wrapTimeReport } from '../../lib/bk-report';

export const SettingRouter = () => {
  const commonDispatch = useDispatch<any>();

  const [companyInfo, setCompanyInfo] = useState<IAPICompanyFullInfo | null>();
  const [accountInfo, setAccountInfo] = useState<IMidasAccountInfo | null>();

  useEffect(() => {
    wrapTimeReport(init);
  }, []);

  const init = async () => {
    const studioID = formatStudioIDByPathname();
    if (!studioID) {
      return false;
    }

    const companyInfo = await getStudioCert(commonDispatch)(studioID);
    const accountRes = await getMidasAccountInfo(studioID);

    setCompanyInfo(companyInfo);
    setAccountInfo(accountRes);
  };

  const formatStudioIDByPathname = () => {
    const { pathname } = location;
    if (pathname.startsWith('/studio')) {
      return pathname.split('/')[2];
    }
    return null;
  };

  const renderComponent = (props: IComponentProps) => {
    return (
      <PermissionCheck contentType="page" anyPermission={true}>
        <>
          <div className={styles.head}></div>
          <SettingContentComponent
            {...props}
            onReload={async () => {
              props.onReload();
              init();
              return true;
            }}
            companyInfo={companyInfo}
            accountInfo={accountInfo}
          />
        </>
      </PermissionCheck>
    );
  };

  return (
    <MainWrapper
      title={getFormatMessage('setting')}
      renderComponent={renderComponent}
    />
  );
};
